var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeofloLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 28,
    viewBox: "0 0 99 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9364 4.46587L11.6977 17.7046L4.34286 10.6649L7.6 7.40779L11.0148 10.8225L19.1501 2.68723C17.1261 1.00953 14.5283 0 11.694 0C5.23559 0 0 5.23554 0 11.694C0 14.8193 1.22613 17.6583 3.22351 19.7562L3.22336 19.7561L12.1402 28V23.3786C18.3917 23.1439 23.3879 18.0028 23.3879 11.6939C23.3879 10.4499 23.1929 9.25157 22.8331 8.12699L24.9364 4.46587Z",
    fill: "url(#paint0_linear_5544_88396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5648 20.7335C89.5777 20.7335 87.9632 20.0795 86.7213 18.7713C85.4959 17.4631 84.8832 15.8734 84.8832 14.0023C84.8832 12.1311 85.4959 10.5414 86.7213 9.23322C87.9632 7.90849 89.5777 7.24613 91.5648 7.24613C93.5685 7.24613 95.183 7.90849 96.4084 9.23322C97.6503 10.5414 98.2713 12.1311 98.2713 14.0023C98.2713 15.8734 97.6503 17.4631 96.4084 18.7713C95.183 20.0795 93.5685 20.7335 91.5648 20.7335ZM87.839 14.0023C87.839 15.2276 88.1868 16.2212 88.8822 16.9829C89.5943 17.7446 90.4885 18.1255 91.5648 18.1255C92.6577 18.1255 93.5519 17.7446 94.2474 16.9829C94.9594 16.2212 95.3155 15.2276 95.3155 14.0023C95.3155 12.7603 94.9594 11.7585 94.2474 10.9968C93.5519 10.2351 92.6577 9.85419 91.5648 9.85419C90.4885 9.85419 89.5943 10.2351 88.8822 10.9968C88.1868 11.7585 87.839 12.7603 87.839 14.0023Z",
    fill: "url(#paint1_linear_5544_88396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0609 7.54419V6.17806C73.0609 4.72086 73.4335 3.62796 74.1787 2.89935C74.9239 2.17075 75.9422 1.80645 77.2339 1.80645L78.2274 1.88097V4.48903C78.128 4.45591 77.9459 4.43935 77.681 4.43935C77.0848 4.43935 76.6543 4.58839 76.3893 4.88645C76.1409 5.16796 76.0168 5.65645 76.0168 6.35193V7.54419H78.3019V9.90387H76.0168V20.4355H73.0609V9.90387H70.9993V7.54419H73.0609ZM80.3884 16.5855V1.80645H83.3442V16.6352C83.3442 17.2975 83.7085 17.6287 84.4371 17.6287L84.9587 17.6039V20.4106C84.6772 20.4603 84.3791 20.4852 84.0645 20.4852C82.7894 20.4852 81.8538 20.1623 81.2577 19.5165C80.6782 18.8706 80.3884 17.8937 80.3884 16.5855Z",
    fill: "url(#paint2_linear_5544_88396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2374 20.7335C62.2503 20.7335 60.6358 20.0795 59.3938 18.7713C58.1685 17.4631 57.5558 15.8734 57.5558 14.0023C57.5558 12.1311 58.1685 10.5414 59.3938 9.23322C60.6358 7.90849 62.2503 7.24613 64.2374 7.24613C66.241 7.24613 67.8556 7.90849 69.0809 9.23322C70.3229 10.5414 70.9438 12.1311 70.9438 14.0023C70.9438 15.8734 70.3229 17.4631 69.0809 18.7713C67.8556 20.0795 66.241 20.7335 64.2374 20.7335ZM60.5116 14.0023C60.5116 15.2276 60.8593 16.2212 61.5548 16.9829C62.2668 17.7446 63.161 18.1255 64.2374 18.1255C65.3303 18.1255 66.2245 17.7446 66.92 16.9829C67.632 16.2212 67.988 15.2276 67.988 14.0023C67.988 12.7603 67.632 11.7585 66.92 10.9968C66.2245 10.2351 65.3303 9.85419 64.2374 9.85419C63.161 9.85419 62.2668 10.2351 61.5548 10.9968C60.8593 11.7585 60.5116 12.7603 60.5116 14.0023Z",
    fill: "url(#paint3_linear_5544_88396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9127 14.8468H47.1014C47.2173 15.8734 47.5899 16.6931 48.2191 17.3058C48.8484 17.9019 49.6763 18.2 50.703 18.2C51.3819 18.2 51.9946 18.0344 52.5411 17.7032C53.0875 17.372 53.4767 16.9249 53.7085 16.3619H56.6891C56.2917 17.6701 55.5466 18.7299 54.4537 19.5413C53.3773 20.3361 52.1023 20.7335 50.6285 20.7335C48.7076 20.7335 47.1511 20.096 45.9588 18.821C44.7831 17.5459 44.1953 15.9314 44.1953 13.9774C44.1953 12.0731 44.7914 10.4752 45.9837 9.18355C47.1759 7.89193 48.7159 7.24613 50.6037 7.24613C52.4914 7.24613 54.0148 7.88366 55.174 9.15871C56.3497 10.4172 56.9375 12.0069 56.9375 13.9277L56.9127 14.8468ZM50.6037 9.65548C49.6763 9.65548 48.9063 9.92871 48.2937 10.4752C47.681 11.0216 47.3001 11.7502 47.1511 12.661H54.0066C53.8741 11.7502 53.5098 11.0216 52.9137 10.4752C52.3175 9.92871 51.5475 9.65548 50.6037 9.65548Z",
    fill: "url(#paint4_linear_5544_88396)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.716 10.6987H39.0379C39.9984 10.6987 40.7104 10.4752 41.1741 10.0281C41.6543 9.58097 41.8944 8.96 41.8944 8.16516C41.8944 7.37032 41.6543 6.74107 41.1741 6.27742C40.6939 5.81376 39.9818 5.58193 39.0379 5.58193H34.716V10.6987ZM34.716 13.4806V20.4355H31.7105V2.8H39.0131C41.0168 2.8 42.4988 3.29677 43.4592 4.29032C44.4362 5.26731 44.9247 6.55892 44.9247 8.16516C44.9247 9.75484 44.4279 11.0382 43.4344 12.0152C42.4408 12.9922 40.9671 13.4806 39.0131 13.4806H34.716Z",
    fill: "url(#paint5_linear_5544_88396)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5544_88396",
    x1: 9.49034e-8,
    y1: 28,
    x2: 99.9915,
    y2: 16.6081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AC275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5544_88396",
    x1: 9.49034e-8,
    y1: 28,
    x2: 99.9915,
    y2: 16.6081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AC275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5544_88396",
    x1: 9.49034e-8,
    y1: 28,
    x2: 99.9915,
    y2: 16.6081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AC275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5544_88396",
    x1: 9.49034e-8,
    y1: 28,
    x2: 99.9915,
    y2: 16.6081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AC275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5544_88396",
    x1: 9.49034e-8,
    y1: 28,
    x2: 99.9915,
    y2: 16.6081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AC275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5544_88396",
    x1: 9.49034e-8,
    y1: 28,
    x2: 99.9915,
    y2: 16.6081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0AC275"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeofloLogo);
export default __webpack_public_path__ + "static/media/peoflo_logo.bab66305c5e067ba40477fa0a95748d1.svg";
export { ForwardRef as ReactComponent };